export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/calendar_report_icon.6bd8535c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};